/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fieldset-checkbox legend>label{display:inline-block;margin-bottom:0;padding-left:5px;font-size:inherit}label.child{padding-left:20px}.btn.btn-primary{margin-right:5px}"];
export { styles as styles };
